import { Box, Button } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import JsonRender, { IContentAPI } from "../JsonRender";
import QuestionHeader from "../components/QuizHeader";

type Status = "completed" | "not-started";

export type IFeedbackProps = {
  status: Status;
  question: IConfig[];
  options: IConfig[];
  correctOption: number;
  feedbackOnCorrect: IConfig[];
  feedbackOnWrong: IConfig[];
  onChange?: (value: number) => void;
  selectedOption: Status extends "completed" ? number : undefined;
  contentAPI: IContentAPI;
  meta?: any;
};

const FeedbackQuiz = ({
  question,
  options,
  correctOption,
  status,
  feedbackOnCorrect,
  feedbackOnWrong,
  onChange,
  contentAPI,
  selectedOption,
  meta,
}: IFeedbackProps) => {
  const [value, setValue] = useState<number | null>(null);

  useEffect(() => {
    if (status === "completed" && selectedOption) {
      setValue(selectedOption);
    }
    if (meta && meta.value && meta.answer) {
      setValue(meta.value);
    }
  }, [status, meta]);

  useEffect(() => {
    if (value !== null) {
      contentAPI.answer_revealed();
    }

    if (onChange && value) {
      onChange(value);
    }
  }, [value]);

  const handleChange = (index: number) => {
    if (!value) {
      setValue(index);
      if (correctOption === index) {
        contentAPI.completed({ value: index, answer: "correct" });
      } else {
        contentAPI.completed({ value: index, answer: "wrong" });
      }
    }
  };

  return (
    <Box>
      <Box>
        <QuestionHeader question={question} />
      </Box>
      <Box
        mt={"1rem"}
        display={"flex"}
        gap={".8rem"}
        flexDirection={"row"}
        flexWrap={"wrap"}
        px={"1.5rem"}
      >
        {options.map((element, index) => (
          <Box key={index}>
            <Button
              as={"div"}
              onClick={() => handleChange(index)}
              size={"lg"}
              borderRadius={"1rem"}
              px={0}
              py={".3rem"}
              height={"auto"}
              border={"1px solid"}
              borderColor={"whiteAlpha.300"}
              bg={
                value === index
                  ? "whiteAlpha.300"
                  : value !== null
                  ? "transparent"
                  : "whiteAlpha.300"
              }
              variant={value === index ? "solid" : "outline"}
              sx={{
                pointerEvents: value !== null ? "none" : "inherit",
              }}
              display={"flex"}
              justifyContent={"center"}
              alignItems={"center"}
            >
              <JsonRender mode="view" content={[element]} />
            </Button>
          </Box>
        ))}
      </Box>
      <Box mt={"2.2rem"}>
        {value !== null && value === correctOption && (
          <JsonRender mode="view" content={feedbackOnCorrect} />
        )}
        {value !== null && value !== correctOption && (
          <JsonRender mode="view" content={feedbackOnWrong} />
        )}
      </Box>
    </Box>
  );
};

export default FeedbackQuiz;
